import { render, staticRenderFns } from "./MajorManage.vue?vue&type=template&id=fe2a9d88&scoped=true&"
import script from "./MajorManage.vue?vue&type=script&lang=js&"
export * from "./MajorManage.vue?vue&type=script&lang=js&"
import style0 from "./MajorManage.vue?vue&type=style&index=0&id=fe2a9d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a9d88",
  null
  
)

export default component.exports